import { View, Text } from '@react-pdf/renderer';
import React from 'react';

import { PDFKinematicGraphSection } from '@/components/PDFDownload/Components/PDFKinematicGraphSection';
import { PDFMobilityStatus } from '@/components/PDFDownload/Components/PDFMobilityStatus';
import { PDFPage } from '@/components/PDFDownload/Components/PDFPage';
import { WalkAnalysisCards } from '@/components/PDFDownload/Components/PDFWalkAnalysis';
import { PDFWalkInfoTable } from '@/components/PDFDownload/Components/PDFWalkInfoTable';
import { PDFVersion } from '@/components/PDFDownload/PDFDocument';
import { PDFFormatting, PDFTextStyles } from '@/components/PDFDownload/styles';

export interface DocumentProps {
  reportInfo: any;
  data: any;
  version: PDFVersion;
}

export const PDFWalkReport = ({ reportInfo, data, version }: DocumentProps) => {
  const reportName = reportInfo.reportName;
  const logoUrl = data.logoURL;
  return (
    <>
      {/* MObility Status & Analysis Cards */}
      <PDFPage PageNumber={1} logoUrl={logoUrl} reportName={reportName}>
        <PDFMobilityStatus data={data} />
        <WalkAnalysisCards kpiData={data.kpiData} kpiLabels={data.kpiLabels} romData={data.romData} />
      </PDFPage>

      {/*Table */}
      <PDFPage PageNumber={2} logoUrl={logoUrl} reportName={reportName}>
        <View style={PDFFormatting.contentContainer_45H}>
          <View style={PDFFormatting.tableContainer}>
            <Text style={PDFTextStyles.containerTitle}>Info</Text>
            <PDFWalkInfoTable romData={data.romData} spatioTemporalData={data.spatioTemporalData} />
          </View>
        </View>
      </PDFPage>

      {/* Kinematic Graphs */}
      {version === 'Specialist' && (
        <PDFPage PageNumber={3} logoUrl={logoUrl} reportName={reportName}>
          <PDFKinematicGraphSection
            coronalGraph={data.pelvisKinematicCoronalChartDataUri}
            sagittalGraph={data.pelvisKinematicSagittalChartDataUri}
            title={'Pelvis'}
            transversalGraph={data.pelvisKinematicTransversalChartDataUri}
          />
          <PDFKinematicGraphSection
            coronalGraph={data.hipKinematicCoronalChartDataUri}
            sagittalGraph={data.hipKinematicSagittalChartDataUri}
            title={'Hip'}
            transversalGraph={data.hipKinematicTransversalChartDataUri}
          />
          <PDFKinematicGraphSection
            coronalGraph={data.kneeKinematicCoronalChartDataUri}
            sagittalGraph={data.kneeKinematicSagittalChartDataUri}
            title={'Knee'}
            transversalGraph={data.kneeKinematicTransversalChartDataUri}
          />
          <PDFKinematicGraphSection
            coronalGraph={data.ankleKinematicCoronalChartDataUri}
            sagittalGraph={data.ankleKinematicSagittalChartDataUri}
            title={'Ankle'}
            transversalGraph={data.ankleKinematicTransversalChartDataUri}
          />
        </PDFPage>
      )}
    </>
  );
};
